<template>
  <ubi-page-container>
    <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-panel>
        <div v-if="statusConnexion === true" v-html="$t('portals.list.selogerMessaqeAuthorisationOk')"></div>
        <div v-else class="text-danger" v-html="$t('portals.list.selogerMessaqeAuthorisationKo')"></div>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>

<script>

import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'PortalSeloger',
  inject: ['browserContext'],
  components: { UbiPanel },
  data () {
    return {
      loading: false,
      statusConnexion: null
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    }
  },
  mounted () {
    this.loading = true
    this.showMessage()
    this.loading = false
  },
  methods: {
    showMessage () {
      if (this.sitimmoUser && this.sitimmoUser.selogerUrlConnexion) {
        this.statusConnexion = true
      }
    }
  }
}
</script>
